export const FIELD_ISSUES_FETCH_CUSTOMIZATION_METADATA = 'FIELD_ISSUES_FETCH_CUSTOMIZATION_METADATA';
export const ISSUE_TYPES_FETCH_START = 'ISSUE_TYPES_FETCH_START';
export const ISSUE_TYPES_FETCH_API = 'ISSUE_TYPES_FETCH_API';
export const ISSUE_TYPES_FETCH_API_FULFILLED = 'ISSUE_TYPES_FETCH_API_FULFILLED';
export const ISSUE_TYPES_FETCH_API_REJECTED = 'ISSUE_TYPES_FETCH_API_REJECTED';
export const ISSUE_TYPES_CREATE_START = 'ISSUE_TYPES_CREATE_START';
export const ISSUE_TYPES_CREATE_API = 'ISSUE_TYPES_CREATE_API';
export const ISSUE_TYPES_CREATE_API_FULFILLED = 'ISSUE_TYPES_CREATE_API_FULFILLED';
export const ISSUE_TYPES_CREATE_API_REJECTED = 'ISSUE_TYPES_CREATE_API_REJECTED';
export const ISSUE_SUB_TYPES_CREATE_START = 'ISSUE_SUB_TYPES_CREATE_START';
export const ISSUE_SUB_TYPES_CREATE_API = 'ISSUE_SUB_TYPES_CREATE_API';
export const ISSUE_SUB_TYPES_CREATE_API_FULFILLED = 'ISSUE_SUB_TYPES_CREATE_API_FULFILLED';
export const ISSUE_SUB_TYPES_CREATE_API_REJECTED = 'ISSUE_SUB_TYPES_CREATE_API_REJECTED';

export const ISSUE_TYPES_UPDATE_STATUS_START = 'ISSUE_TYPES_UPDATE_STATUS_START';
export const ISSUE_TYPES_UPDATE_STATUS_API = 'ISSUE_TYPES_UPDATE_STATUS_API';
export const ISSUE_TYPES_UPDATE_STATUS_API_FULFILLED = 'ISSUE_TYPES_UPDATE_STATUS_API_FULFILLED';
export const ISSUE_TYPES_UPDATE_STATUS_API_REJECTED = 'ISSUE_TYPES_UPDATE_STATUS_API_REJECTED';

export const ISSUE_TYPES_UPDATE_TITLE_START = 'ISSUE_TYPES_UPDATE_TITLE_START';
export const ISSUE_TYPES_UPDATE_TITLE_API = 'ISSUE_TYPES_UPDATE_TITLE_API';
export const ISSUE_TYPES_UPDATE_TITLE_API_FULFILLED = 'ISSUE_TYPES_UPDATE_TITLE_API_FULFILLED';
export const ISSUE_TYPES_UPDATE_TITLE_API_REJECTED = 'ISSUE_TYPES_UPDATE_TITLE_API_REJECTED';

export const ISSUE_TYPES_SELECT_FOR_EDIT = 'ISSUE_TYPES_SELECT_FOR_EDIT';
export const ISSUE_TYPES_UPDATE_START = 'ISSUE_TYPES_UPDATE_START';
export const ISSUE_TYPES_UPDATE_API = 'ISSUE_TYPES_UPDATE_API';
export const ISSUE_TYPES_UPDATE_API_PENDING = 'ISSUE_TYPES_UPDATE_API_PENDING';
export const ISSUE_TYPES_UPDATE_API_FULFILLED = 'ISSUE_TYPES_UPDATE_API_FULFILLED';
export const ISSUE_TYPES_UPDATE_API_REJECTED = 'ISSUE_TYPES_UPDATE_API_REJECTED';

export const ISSUE_TYPES_SET_SELECTED_ATTRIBUTES = 'ISSUE_TYPES_SET_SELECTED_ATTRIBUTES';
export const ISSUE_TYPES_REMOVE_SELECTED_ATTRIBUTE = 'ISSUE_TYPES_REMOVE_SELECTED_ATTRIBUTE';
export const ISSUE_TYPES_SET_SELECTED_ATTRIBUTE_DEFINITIONS = 'ISSUE_TYPES_SET_SELECTED_ATTRIBUTE_DEFINITIONS';
export const ISSUE_TYPES_SET_SELECTED_ATTRIBUTE_MAPPING_REQUIRED =
  'ISSUE_TYPES_SET_SELECTED_ATTRIBUTE_MAPPING_REQUIRED';
export const ISSUE_TYPES_SET_ATTRIBUTE_MAPPINGS = 'ISSUE_TYPES_SET_ATTRIBUTE_MAPPINGS';

export const SHOW_ISSUE_TYPES_EDIT_MODAL = 'SHOW_ISSUE_TYPES_EDIT_MODAL';
export const SHOW_ISSUE_TYPES_ADD_ATTRIBUTES_MODAL = 'SHOW_ISSUE_TYPES_ADD_ATTRIBUTES_MODAL';

export const SHOW_ISSUE_TYPES_LEAVE_ADD_ATTRIBUTES_MODAL = 'SHOW_ISSUE_TYPES_LEAVE_ADD_ATTRIBUTES_MODAL';

export const ISSUE_TYPES_PENDING_UPDATE = 'ISSUE_TYPES_PENDING_UPDATE';
export const ISSUE_TYPES_UPDATE_NOTIFICATION_SHOW = 'ISSUE_TYPES_UPDATE_NOTIFICATION_SHOW';

export const fetchIssuesCustomizationMetadata = () => ({
  type: FIELD_ISSUES_FETCH_CUSTOMIZATION_METADATA
});

export const fetchIssueTypesAction = () => ({
  type: ISSUE_TYPES_FETCH_START
});

export const createIssueTypeAction = (payloadObj, meta) => ({
  type: ISSUE_TYPES_CREATE_START,
  payload: payloadObj,
  meta
});

export const createIssueSubTypeAction = payloadObj => ({
  type: ISSUE_SUB_TYPES_CREATE_START,
  payload: payloadObj
});

export const updateIssueTypeStatusAction = (id, isActive, parentId) => ({
  type: ISSUE_TYPES_UPDATE_STATUS_START,
  payload: {id, isActive, parentId}
});

export const updateIssueTypeTitleAction = (id, title, parentId) => ({
  type: ISSUE_TYPES_UPDATE_TITLE_START,
  payload: {id, title, parentId}
});

export const selectIssueTypeForEdit = id => ({
  type: ISSUE_TYPES_SELECT_FOR_EDIT,
  payload: {id}
});

export const updateIssueTypeAction = (onSuccessUpdateIssueType, onSuccessUpdateIssueTypeMappings) => ({
  type: ISSUE_TYPES_UPDATE_START,
  payload: {onSuccessUpdateIssueType, onSuccessUpdateIssueTypeMappings}
});

export const setSelectedIssueTypeAttributesAction = attributes => ({
  type: ISSUE_TYPES_SET_SELECTED_ATTRIBUTES,
  payload: {attributes}
});

export const setSelectedIssueTypeDefinitionsAction = definitions => ({
  type: ISSUE_TYPES_SET_SELECTED_ATTRIBUTE_DEFINITIONS,
  payload: {definitions}
});

export const setSelectedIssueTypeMappingRequiredAction = (mapping, isRequired) => ({
  type: ISSUE_TYPES_SET_SELECTED_ATTRIBUTE_MAPPING_REQUIRED,
  payload: {
    mapping,
    isRequired
  }
});

export const removeIssueAttributeMappingAction = id => ({
  type: ISSUE_TYPES_REMOVE_SELECTED_ATTRIBUTE,
  payload: {id}
});

export const showIssueTypesEditModalAction = (visible, shouldOpenCreateAttributeModal) => ({
  type: SHOW_ISSUE_TYPES_EDIT_MODAL,
  payload: {visible},
  meta: {shouldOpenCreateAttributeModal}
});

export const showIssueTypesAddAttributesModalAction = visible => ({
  type: SHOW_ISSUE_TYPES_ADD_ATTRIBUTES_MODAL,
  payload: {visible}
});

export const showIssueTypesLeaveAddAttributesModalAction = visible => ({
  type: SHOW_ISSUE_TYPES_LEAVE_ADD_ATTRIBUTES_MODAL,
  payload: {visible}
});

export const updatePendingIssueTypeAction = attributes => ({
  type: ISSUE_TYPES_PENDING_UPDATE,
  payload: attributes
});

export const showIssueTypeUpdatedNotificationAction = isSubType => ({
  type: ISSUE_TYPES_UPDATE_NOTIFICATION_SHOW,
  payload: {isSubType}
});
